import PropTypes from 'prop-types'

import { Button, FormRow, Label, WithTooltip } from 'basic-components'
import { Info } from 'basic-components/icons'

const COLUMNS_TOOLTIP = "If at least one column is specified, only columns matching the RegExps in mandatory and optional columns may be used. Name is RegExp, Values are RegExps - at least one of them has to be fullfiled."

const ColumnsAdder = ({ label, onAdd }) => (
  <FormRow className="data-lake__group-dialog__advanced__ncsv-columns__adder">
    <Label
        noError
        size="big"
    >
      {label}
      <WithTooltip text={COLUMNS_TOOLTIP}>
        <div className="data-lake__group-dialog__advanced__ncsv-columns__adder__tooltip">
          <Info
              color="blue-bright"
              height={16}
              width={16}
          />
        </div>
      </WithTooltip>
    </Label>
    <Button
        onClick={onAdd}
        size="small"
        type="button"
        variant="text"
    >
      Add column
    </Button>
  </FormRow>
)

ColumnsAdder.propTypes = {
  label: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired
}

export default ColumnsAdder
